import { render, staticRenderFns } from "./SendMessages.vue?vue&type=template&id=7373cbfc&scoped=true&"
import script from "./SendMessages.vue?vue&type=script&lang=js&"
export * from "./SendMessages.vue?vue&type=script&lang=js&"
import style0 from "./SendMessages.vue?vue&type=style&index=0&id=7373cbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373cbfc",
  null
  
)

export default component.exports